/* Castilan: common hover/touch behavior for Home, recommendations and all product cards. */
(() => {
  if (window.__castilanTouchPreviewReady) return;
  window.__castilanTouchPreviewReady = true;
  const selector='a.cf26-image, a.cdr__media, .card-gallery a[ref="cardGalleryLink"]';
  let active=null;
  let preventNextClick=null;
  function getVisual(link){
    if(!link)return null;
    if(link.matches('.cf26-image'))return link.querySelector('.cf26-hover-media')?link:null;
    if(link.matches('.cdr__media'))return link.querySelector('.cdr__hover-media')?link:null;
    const gallery=link.closest('.card-gallery');
    return gallery&&gallery.querySelector('.castilan-card-preview-layer')?gallery:null;
  }
  function getVideo(visual){return visual?.querySelector('video.cf26-hover-video,video.cdr__hover-video,video.castilan-card-preview-video')||null;}
  function play(visual){
    const video=getVideo(visual);
    if(!video)return;
    const result=video.play();
    if(result&&typeof result.catch==='function')result.catch(()=>{});
  }
  function pause(visual){
    const video=getVideo(visual);
    if(!video)return;
    video.pause();
    try{video.currentTime=0;}catch(_error){}
  }
  function clear(){
    if(!active)return;
    active.visual.classList.remove('is-touch-preview');
    pause(active.visual);
    active=null;
  }
  // First finger tap previews, second navigates. No movement/cancel threshold.
  document.addEventListener('pointerdown',(event)=>{
    if(event.pointerType!=='touch'&&event.pointerType!=='pen')return;
    const link=event.target.closest?.(selector);
    const visual=getVisual(link);
    if(!visual){clear();preventNextClick=null;return;}
    if(active?.link===link){preventNextClick=null;return;}
    clear();
    active={link,visual};
    visual.classList.add('is-touch-preview');
    preventNextClick=link;
    play(visual);
  },true);
  document.addEventListener('click',(event)=>{
    const link=event.target.closest?.(selector);
    if(link&&preventNextClick===link){
      event.preventDefault();
      event.stopImmediatePropagation();
      preventNextClick=null;
    }
  },true);
  // Hover for all cards uses the same lifecycle.
  document.addEventListener('pointerover',(event)=>{
    if(event.pointerType!=='mouse')return;
    const link=event.target.closest?.(selector);
    if(!link||link.contains(event.relatedTarget))return;
    play(getVisual(link));
  },true);
  document.addEventListener('pointerout',(event)=>{
    if(event.pointerType!=='mouse')return;
    const link=event.target.closest?.(selector);
    if(!link||link.contains(event.relatedTarget))return;
    pause(getVisual(link));
  },true);
  document.addEventListener('focusin',(event)=>{
    const link=event.target.closest?.(selector);
    if(link)play(getVisual(link));
  },true);
  document.addEventListener('focusout',(event)=>{
    const link=event.target.closest?.(selector);
    if(link&&!link.contains(event.relatedTarget)&&active?.link!==link)pause(getVisual(link));
  },true);
})();